import { handleActions } from 'redux-actions';
import module from 'lib/module';
import { NAME } from './constants';
import { initialState } from './model';

const reducer = module(handleActions({}, initialState), NAME);

export default reducer;
